module.exports = __webpack_public_path__ + "frontend/images/faq/screen-payment-submit-xs-5ae7745251319c3160a097241d320519.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-payment-submit-xs.jpg
// module id = 348
// module chunks = 2